import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    justifyRight: {
      justifyContent: 'right'
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      position: 'relative',
      left: 10
    },
    inlineButton: {
      margin: '5px 10px'
    }
  })
);
